import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal } from 'state/actions';
import { MODAL, COLOR, ADD_NEW_FAVORITE_LISTING_STEP, ALERT } from 'config/constants';
import { useAuth, useLanguage, useAddFavoriteListing, useAlert } from 'hooks';
import { HvModal, HvButton, HvStepperDots } from 'components';
import { isMobile } from 'utils/screen';
import ListingCard from './ListingCard';

const useStyles = makeStyles({
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: 900,
    '@media (max-width: 839px)': {
      width: 720,
    },
    '@media (max-width: 768px)': {
      width: 700,
    },
    '@media (max-width: 560px)': {
      width: 500,
    },
    '@media (max-width: 414px)': {
      width: 330,
    },
    '@media (max-width: 380px)': {
      width: 300,
    },
    '@media (max-width: 300px)': {
      width: 280,
    },
  },
  confirmListingsContent: {
    maxHeight: '100%',
    overflowY: 'auto',
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 300px)',
    justifyContent: 'space-between',
    width: '100%',
    flexGrow: 1,
    marginTop: 30,
    '@media (max-width: 767px)': {
      justifyContent: 'center',
    },
  },
  stickyDots: {
    marginBottom: 10,
  },
});
interface Props {
  setActiveStep: (_: number) => void;
  activeStep: number;
  selectedListings: any;
  setSelectedListings: (_: any) => void;
  favorite_listings: [];
}
function ConfirmNewFavoriteListing({
  setActiveStep,
  activeStep,
  selectedListings,
  setSelectedListings,
  favorite_listings,
}: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const dispatch = useDispatch();
  const { displayAlert } = useAlert();
  const { user, token } = useAuth();
  const { addFavoriteListing } = useAddFavoriteListing(token, selectedListings, user.id);
  const path = window.location.pathname;

  const onClose = () => {
    dispatch(hideModal(MODAL.ADD_NEW_FAVORITE_LISTING));
  };
  const onBack = () => {
    setActiveStep(ADD_NEW_FAVORITE_LISTING_STEP.OPTIONS);
  };

  const onAdd = async () => {
    addFavoriteListing(token, selectedListings, user.id);
  };
  const buttons = (
    <Box>
      <HvButton className={styles.cancelButton} onClick={onBack}>
        {intl.formatMessage({ id: 'deliver.photos.back' })}
      </HvButton>
      <HvButton onClick={onAdd}>{intl.formatMessage({ id: 'deliver.photos.save' })}</HvButton>
    </Box>
  );

  return (
    <HvModal
      title={intl.formatMessage({ id: 'portal.confirmListings' })}
      buttons={buttons}
      onClose={onClose}
      largerWidth
      fullScreen={isMobile()}
    >
      <Box className={styles.modalContent}>
        <Box className={styles.confirmListingsContent}>
          {selectedListings.map((l) => {
            return (
              <ListingCard
                key={l.id}
                listingWithServiceOffer={l}
                setActiveStep={setActiveStep}
                selectedListings={selectedListings}
                setSelectedListings={setSelectedListings}
                favorite_listings={favorite_listings}
                previousStep={ADD_NEW_FAVORITE_LISTING_STEP.OPTIONS}
              />
            );
          })}
        </Box>
        <Box className={styles.stickyDots}>
          <HvStepperDots activeDot={2} numberOfDots={3} />
        </Box>
      </Box>
    </HvModal>
  );
}
export default ConfirmNewFavoriteListing;
